"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _renderProps = require("../../../libs/renderProps");

var _FilterOption = _interopRequireDefault(require("./FilterOption"));

var _SearchableFilterSelector = _interopRequireDefault(require("./SearchableFilterSelector"));

var _excluded = ["items"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var OverviewFilterTitle = function OverviewFilterTitle(_ref) {
  var children = _ref.children;
  return (0, _preact.h)("div", {
    className: "overview__filters-box-filter overview__filters-box-filter-title"
  }, " ", children, " ");
};

var SimpleFilterSelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SimpleFilterSelector, _Component);

  var _super = _createSuper(SimpleFilterSelector);

  function SimpleFilterSelector(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SimpleFilterSelector);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "wrapperRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFilterOptionSelection", function (payload) {
      _this.setState({
        data: payload
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickSelectAll", function (filteredItems) {
      _this.setState(function (prevState) {
        var _this$props$selectedF, _this$props$items;

        var isSelectAll = !prevState.isSelectAll;

        if (!isSelectAll) {
          var _selected = filteredItems !== null && filteredItems !== void 0 && filteredItems.length ? filteredItems.reduce(function (data, item) {
            return data.filter(function (dataItem) {
              return dataItem !== String(item.value);
            });
          }, prevState.data) : [];

          return {
            isSelectAll: isSelectAll,
            data: _selected
          };
        }

        var selected = filteredItems !== null && filteredItems !== void 0 && filteredItems.length ? [].concat((0, _toConsumableArray2.default)((_this$props$selectedF = _this.props.selectedFilterItems) !== null && _this$props$selectedF !== void 0 ? _this$props$selectedF : []), (0, _toConsumableArray2.default)(filteredItems.map(function (item) {
          return String(item.value);
        }))) : ((_this$props$items = _this.props.items) === null || _this$props$items === void 0 ? void 0 : _this$props$items.map(function (item) {
          return String(item.value);
        })) || [];
        return {
          isSelectAll: isSelectAll,
          data: (0, _toConsumableArray2.default)(new Set(selected))
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setWrapperRef", function (node) {
      _this.wrapperRef = node;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSearchInputChange", function (filteredItems) {
      return _this.setState({
        isSelectAll: filteredItems.every(function (item) {
          return _this.state.data.includes(String(item.value));
        })
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (event) {
      var isOutside = _this.wrapperRef && !_this.wrapperRef.contains(event.target);

      if (isOutside && _this.props.onClickOutside) {
        _this.props.onClickOutside();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderItem", function (item, index) {
      if (item.name === 'separator') {
        return (0, _preact.h)("hr", {
          className: "separator"
        });
      }

      if (item.name === 'title') {
        return (0, _preact.h)(OverviewFilterTitle, null, item.value);
      }

      var _this$state = _this.state,
          data = _this$state.data,
          isSelectAll = _this$state.isSelectAll;
      return (0, _preact.h)(_FilterOption.default, {
        key: index,
        item: item,
        data: data,
        onFilterOptionSelection: _this.onFilterOptionSelection,
        isSelectAll: isSelectAll
      });
    });
    var _this$props = _this.props,
        selectedFilterItems = _this$props.selectedFilterItems,
        items = _this$props.items;
    _this.state = {
      data: selectedFilterItems !== null && selectedFilterItems !== void 0 ? selectedFilterItems : [],
      isSelectAll: (selectedFilterItems === null || selectedFilterItems === void 0 ? void 0 : selectedFilterItems.length) === (items === null || items === void 0 ? void 0 : items.length)
    };
    _this.handleSearchInputChange = _this.handleSearchInputChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(SimpleFilterSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      if (prevState.data !== this.state.data) {
        var _this$props$onChange, _this$props2;

        (_this$props$onChange = (_this$props2 = this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props2, this.state.data);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          name = _this$props3.name,
          items = _this$props3.items,
          isSearchable = _this$props3.isSearchable,
          children = _this$props3.children;
      var _this$state2 = this.state,
          data = _this$state2.data,
          isSelectAll = _this$state2.isSelectAll;
      var selectionLabel = isSelectAll ? 'Deselect all' : 'Select all';
      var renderedChildren = (0, _renderProps.extractRenderPropsChildren)(children)({
        data: data,
        isApplyButtonDisabled: data.length === 0
      });

      if (isSearchable) {
        return (0, _preact.h)("div", {
          ref: this.setWrapperRef
        }, (0, _preact.h)(_SearchableFilterSelector.default, {
          items: items,
          placeholder: "Search for ".concat(name),
          onClickSelectAll: this.onClickSelectAll,
          selectionLabel: selectionLabel,
          handleSearchInputChange: this.handleSearchInputChange
        }, function (_ref2) {
          var items = _ref2.items;

          if (items === undefined) {
            return null;
          }

          return items.map(_this2.renderItem);
        }), renderedChildren);
      }

      return (0, _preact.h)("div", {
        ref: this.setWrapperRef
      }, (0, _preact.h)("p", {
        className: "select-all",
        onClick: function onClick() {
          return _this2.onClickSelectAll();
        }
      }, selectionLabel), items.map(this.renderItem), renderedChildren);
    }
  }]);
  return SimpleFilterSelector;
}(_preact.Component);

(0, _defineProperty2.default)(SimpleFilterSelector, "create", function (config) {
  var items = config.items,
      rest = (0, _objectWithoutProperties2.default)(config, _excluded);
  return _objectSpread({
    component: SimpleFilterSelector,
    type: 'filter',
    getPillDisplayValue: function getPillDisplayValue(data) {
      var _items$find$name, _items$find;

      var firstItem = (_items$find$name = (_items$find = items.find(function (item) {
        return String(item.value) === data[0];
      })) === null || _items$find === void 0 ? void 0 : _items$find.name) !== null && _items$find$name !== void 0 ? _items$find$name : '';
      var otherItems = data.length > 1 ? "+".concat(data.length - 1) : '';
      return "".concat(firstItem, " ").concat(otherItems);
    },
    items: items
  }, rest);
});
var _default = SimpleFilterSelector;
exports.default = _default;